import $ from 'jquery';
import {addItem} from '@shopify/theme-cart';
import {runInSequence} from './utilities';

export default class AjaxAdd {
  constructor(options) {
    this.options = $.extend(
      true,
      {
        selectors: {
          button: '[data-add-to-cart]',
          buttonText: '[data-add-to-cart-text]',
        },
        successWait: 2000,
      },
      options,
    );

    this.$container = this.options.$container;
    this.namespace = this.options.namespace;
    this.$button = $(this.options.selectors.button, this.$container);
    this.$buttonText = $(this.options.selectors.buttonText, this.$container);
    this.requests = [];
    this.reqCount = 0;

    this.bind();
  }

  bind() {
    this.$container.on(`submit${this.namespace}`, this.handleSubmit.bind(this));
  }

  /**
   * @param {Event} event
   * @param {Object} data
   */
  handleSubmit(event, data = {}) {
    event.preventDefault();
    this.setLoading();
    const formData = $(event.target).serializeArray();
    const {id, properties, quantity} = this.convertData(formData);

    if (data.count) {
      this.reqCount = this.reqCount + 1;
    }

    if (id) {
      this.requests.push({
        id: parseInt(id, 10),
        options: {
          quantity: parseInt(quantity, 10),
          properties,
        },
      });
    }

    if (data.count && this.reqCount < data.count) {
      return;
    }

    this.request(this.requests);
  }

  /**
   * @param {Array} data
   */
  convertData(data = []) {
    return data.reduce((accu, item) => {
      if (item.name.indexOf('properties') !== -1) {
        const {properties, ...rest} = accu;
        const prop = item.name.replace('properties[', '').replace(']', '');

        return {
          ...rest,
          properties: {
            ...properties,
            [prop]: item.value,
          },
        };
      }

      return {
        ...accu,
        [item.name]: item.value,
      };
    }, {});
  }

  /**
   * @param {Array} products
   */
  async request(products) {
    try {
      const requests = products.map(item =>
        addItem.bind(null, item.id, item.options),
      );
      const results = await runInSequence(requests);

      this.handleResponse(results);
    } catch (error) {
      this.restore();
    }

    this.reqCount = 0;
    this.requests = [];
  }

  /**
   * @param {Array} results
   */
  handleResponse(results) {
    const failed = results
      .map((val, index) => {
        return val.status ? index : null;
      })
      .filter(val => val !== null);

    if (failed.length >= 1) {
      this.$container.trigger('message', {
        messages: [
          {
            text: theme.strings.failedCart,
            type: 'success',
          },
        ],
      });
    }

    if (failed.length === results.length) {
      this.restore();
      return;
    }

    // Replace once slate bundling deps are fixed
    this.dispatch('cart:updated', {
      bubbles: true,
    });

    this.setAdded();
  }

  setAdded() {
    this.$buttonText.text(theme.strings.cartAdded);
    window.setTimeout(this.restore.bind(this), this.options.successWait);
  }

  setLoading() {
    this.before = {
      disabled: this.$button.attr('disabled') || false,
    };

    this.dispatch('cart:loading');

    this.$button.attr('disabled', true);
    this.$buttonText.text(theme.strings.cartLoading);
  }

  restore() {
    this.$button.attr('disabled', this.before.disabled);
    this.$buttonText.text(theme.strings.addToCart);
    this.dispatch('cart:loaded');

    this.before = {};
  }

  /**
   * @param {String} name
   * @param {Object} data
   */
  dispatch(name = '', data = {}) {
    const event = new window.Event(name, data);

    this.$container.get(0).dispatchEvent(event);
  }
}
